import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '+393453509743';
const WHATSAPP_MESSAGE = encodeURIComponent('Ciao! Vorrei ricevere informazioni sulla consulenza energetica e finanza agevolata.');

const WhatsAppButton = () => {
  const openWhatsApp = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=${WHATSAPP_MESSAGE}`, '_blank');
  };

  return (
    <button
      onClick={openWhatsApp}
      className="whatsapp-float fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform group"
      data-testid="floating-whatsapp-button"
      aria-label="Contattaci su WhatsApp"
    >
      <MessageCircle className="w-7 h-7 md:w-8 md:h-8 text-white" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-[#1e293b] text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
        Scrivici su WhatsApp
      </span>
      
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
    </button>
  );
};

export default WhatsAppButton;
